import { z } from "zod";

export const isObject = obj => typeof obj === 'object' && !(obj instanceof Array) && obj !== null;

export const deepEqual = (x, y) => {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
      ok(x).every(key => deepEqual(x[key], y[key]))
  ) : (x === y);
}

export const getRef = (openapi, ref) => {
  let position = openapi;
  const parts = ref.split('/');
  for (let idx = 0; idx < parts.length; idx++) {
    if (parts[idx] === '#') {
      position = position;
    } else {
      position = position[parts[idx]];
    }
  }

  return position;
}

export const initSchemaValues = schema => {
  const value = {};
  for (const [id, prop] of Object.entries(schema.properties)) {
    if (prop.default) {
      value[id] = prop.default;
    } else {
      switch (prop.type) {
        case 'array':
          value[id] = [];
          break;
        case 'object':
          value[id] = {};
          break;
        default:
          value[id] = undefined;
      }
    }
  }
  return value;
}

export const file2base64 = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;

    reader.readAsDataURL(file);
  })
}

export const _ = (text, texts, fallback = null) => {
  // console.log(text, texts, fallback)
  if (!texts) return fallback;
  let obj = texts;
  for (const key of text.split('.')) {
    if (Object.keys(obj).includes(key)) {
      obj = obj[key]
    } else {
      return fallback;
    }
  }
  return obj;
}

export const traverse = (data, path) => {
  if (path === "/") return data;
  if (Array.isArray(path)) return traverse_multiple(data, path);
  else return traverse_one(data, path)
}

export const traverse_one = (data, path) => {
  if (!Array.isArray(path)) path = [path];

  for (const option of path) {
    let val = { ...data };
    for (const segment of option.split("/")) {
      if (Object.keys(val).includes(segment)) {
        val = val[segment];
      } else {
        val = null;
        break;
      }
    }
    if (!val) continue;
    return val;
  }
}

export const traverse_multiple = (obj, paths) => {
  for (const path of paths) {
    let o = obj;
    for (const segment of path.split('/')) {
      try { o = o[segment]; }
      catch (er) { break; }
    }
    if (o) return o;
  }
}

export const zProperty = (property, required) => {
  if (property.const) var prop = z.literal(property.const);
  else if (['integer', 'number'].includes(property.type)) prop = z.coerce.number();
  else if (['binary', 'image'].includes(property.format)) prop = z.instanceof(File)
  else {
    prop = z[property.type]();
    if (property.format === 'date-time') prop = z.coerce.date(); // prop.datetime();
    else if (property.format === 'date') prop = prop.date();
    else if (property.widget === 'time') prop = prop.time();

    if (property.maxLength) prop = prop.max(property.maxLength);
  }

  if (!required) prop = prop.optional();

  return prop;
}

export const resolveRef = (openapi, ref) => {
  if (ref.startsWith('#')) {
    return zObject(openapi, traverse(openapi, [ref.substring(2)]));
  } else {
    const asUrl = new URL(ref);
    console.log(asUrl)
  }
}

export const zAnyOf = (openapi, schema, property, id) => {
  const anyOf = [];
  for (const item of property.items.anyOf) {
    if (item.$ref) anyOf.push(resolveRef(openapi, item.$ref));
    else anyOf.push(zProperty(item, false));
  }
  console.log(anyOf)
  const a = z.array(z.union(anyOf));
  if (!schema.required.includes(id)) a.optional();
  return a;
}

export const zOneOf = (openapi, schema, property, id) => {
  const ref = traverse(openapi, [property.items.$ref.substring(2)])
  const oneOf = [];
  for (const item of ref.oneOf) {
    if (item.$ref) oneOf.push(resolveRef(openapi, item.$ref));
  }
  if (schema.discriminator) {
    return z.discriminatedUnion(schema.discriminator.propertyName, oneOf)
  }
}

export const zArray = (openapi, schema, property, id) => {
  if (property.items.anyOf) return zAnyOf(openapi, schema, property, id);
  else if (property.items.$ref) return zOneOf(openapi, schema, property, id);
  else return z.array(zProperty(property.items, schema.required.includes(id)));
}

export const zObject = (openapi, schema) => {
  const properties = {};
  for (const [id, property] of Object.entries(schema.properties)) {
    if (property.type === 'array') properties[id] = zArray(openapi, schema, property, id);
    else if (property.type === 'object') properties[id] = zObject(openapi, schema);
    // else if (property.oneOf) properties[id] = zOneOf(openapi, schema);
    else properties[id] = zProperty(property, schema.required.includes(id));
  }

  return z.object(properties);
}